export default __webpack_public_path__ + "static/media/gravel-icon.ec4c1dcd.svg";